import { format, fromUnixTime } from 'date-fns';

export function ruble(v: number, precision = 2): string {
  const numericValue = parseFloat(v.toString());
  return `${numericValue.toLocaleString('ru', {
    minimumFractionDigits: precision,
  })} ₽`.replace(',', '.');
}

export function formatNumber(v: number, precision = 2): string {
  const numericValue = parseFloat(v.toString());
  return `${numericValue.toLocaleString('ru', {
    minimumFractionDigits: precision,
  })}`.replace(',', '.');
}

export function formatUnixDateTime(v: number | string) {
  return format(fromUnixTime(+v), 'dd.MM.yyyy kk:mm:ss');
}
